/**
 * **C08 · The Form 5089 worksheet** (Stream C, Documents.dc.html): laid out by the `form_5089_page`
 * engine from Money's worksheet (sales tax by area) and its sales-tax filing card (the festival's
 * days, the due date). Scored against the drawing by walk 99g.
 */
import type { ReactNode } from 'react';
import { form5089Page, type CoverFiling } from '@cider/domain/engines';
import { useLoad, type Report } from '../views/money/shared.js';
import { usePrinted } from './printed.js';
import { DrawnPages } from './drawn-doc.js';

export function Form5089({ fy }: { fy: number }): ReactNode {
  // The festival a fiscal year closes is the one held the September before its June 30.
  const year = String(fy - 1);
  const sheet = useLoad<Report>(`/money/reports/form-5089?year=${year}`);
  const filings = useLoad<{ cards: CoverFiling[] }>(`/money/state-filings/${year}`);
  const ready = [sheet, filings].every((l) => l.data !== null || l.error !== null);
  usePrinted('doc-form-5089', ready, { year: fy - 1 });
  if (!ready) return <p>Reading the figures…</p>;
  const by = sheet.data?.status === 'ok' ? sheet.data.sections[0] : undefined;
  const card = filings.data?.cards.find((c) => c.kind === 'sales_tax');
  const total = by?.totals?.[4];
  const due = card?.dueWords ?? '';
  const page = form5089Page({
    rows: by?.rows ?? null,
    totalTaxCents: typeof total === 'number' ? total : null,
    festival: card?.lines.find((l) => l.no === 'E')?.text ?? null,
    due: due === '' ? null : due,
  });
  return <DrawnPages pages={[page]} />;
}
